import FinancialInstitutionRelinkWarning from '@/components/dashboard/FinancialInstitutionRelinkWarning';
import { useMyDisconnectedAccounts } from '@/components/financialEntities/helpers';
import { FlexProps } from '@chakra-ui/react';
import groupBy from 'lodash/groupBy';
import { useMemo } from 'react';
import { FlexCol } from '../common/Flex';
import FinancialEntityRelinkWarning from '../financialEntities/FinancialEntityRelinkWarning';

const DashboardRelinkSection = (props: FlexProps) => {
    const disconnectedAccounts = useMyDisconnectedAccounts();
    const disconnectedAccountsGroupedByInstitution = useMemo(
        () =>
            groupBy(
                disconnectedAccounts,
                (account) =>
                    account.institution?.name || `unknown-${account.id}`
            ),
        [disconnectedAccounts]
    );

    return (
        <FlexCol gap={6} {...props}>
            {Object.entries(disconnectedAccountsGroupedByInstitution).map(
                ([institutionName, accounts]) =>
                    accounts && accounts.length > 1 ? (
                        <FinancialInstitutionRelinkWarning
                            institutionName={institutionName}
                            key={accounts[0].id}
                            accounts={accounts}
                        />
                    ) : (
                        accounts &&
                        accounts.length === 1 && (
                            <FinancialEntityRelinkWarning
                                key={accounts[0].id}
                                account={accounts[0]}
                                includeFinancialEntityWithMask={true}
                            />
                        )
                    )
            )}
        </FlexCol>
    );
};

export default DashboardRelinkSection;
